import type { ReactNode } from 'react';
import { cx } from './cx';
import s from './Segmented.module.css';

export interface SegmentedOption<T extends string> {
  value: T;
  label: ReactNode;
}

/** Tab-like single choice (filters, views). */
export function Segmented<T extends string>({ options, value, onChange, block, label }: { options: SegmentedOption<T>[]; value: T; onChange(v: T): void; block?: boolean; label: string }) {
  return (
    <div className={cx(s.group, block && s.block)} role="tablist" aria-label={label}>
      {options.map((o) => (
        <button key={o.value} role="tab" aria-selected={o.value === value} className={cx(s.item, o.value === value && s.active)} onClick={() => onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
